import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";

const FAQS = [
  { q: "How do I order apparel?", a: "Add items to the cart, then complete checkout via our Printify/Etsy partner store linked from each product page. Every order is made on demand." },
  { q: "How long does shipping take?", a: "Apparel: 5–12 business days worldwide via Printify. Original art & Etsy items: 3–10 business days depending on destination." },
  { q: "Can I request a custom piece?", a: "Yes! Head to Custom Requests, tell us the story, and Cam will reply within 2 business days with a quote and timeline." },
  { q: "Do you paint murals?", a: "We do — from home walls to full commercial exteriors. Submit a custom request with details, budget & location." },
  { q: "Are the artworks originals?", a: "Yes — canvases in the Prints category are original works unless labelled otherwise. Digital designs are downloadable licences." },
  { q: "What's your return policy?", a: "30-day returns on apparel if unworn. Custom & digital items are final sale unless there's a fulfillment defect." },
  { q: "Do you offer wholesale?", a: "For select apparel and prints, yes — email hello@camskooriart.com with your details." },
];

export default function FAQ() {
  return (
    <div data-testid="page-faq" className="max-w-[1000px] mx-auto px-5 md:px-10 py-16">
      <p className="overline mb-3">FAQs</p>
      <h1 className="font-display text-5xl md:text-7xl mb-12">Questions.</h1>
      <Accordion type="single" collapsible className="border-t border-white/10">
        {FAQS.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="border-b border-white/10">
            <AccordionTrigger className="py-6 text-left font-display text-xl md:text-2xl tracking-wider hover:text-[#FF4500]">{f.q}</AccordionTrigger>
            <AccordionContent className="text-white/70 leading-relaxed pb-6">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
